module.exports = __webpack_public_path__ + "static/media/batteries.07ff6d47.gif";